export enum AuthMethod {
  STORAGE = 'storage',
  TOKEN = 'token',
}
